<form [formGroup]="areaRatioForm" *ngIf="areaRatioForm" (ngSubmit)="onSubmit()" class="myform">
    <div class="p-5">

        <div class="flex justify-center items-baseline flex-wrap">
            <div class="myradio">
                <mat-radio-group formControlName="options">
                    <mat-radio-button value="1">Subsonic</mat-radio-button>
                    <mat-radio-button value="2">Supersonic</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div class="flex justify-center items-baseline flex-wrap">
            <div class="flex m-2">
                <mat-form-field [hideRequiredMarker]="true">
                    <mat-label><i>k</i> value</mat-label>
                    <input matInput placeholder="k value" formControlName="gammaVal" autocomplete="off">
                    <mat-error *ngIf="gamma?.invalid && gamma?.touched">
                        <span class="myerror">1.0 &lt; k &le; 1.67</span>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="flex m-2">
  
          <mat-form-field>
            <mat-label>Area ratio</mat-label>

            <input matInput placeholder="Area ratio" formControlName="areaRat" autocomplete="off">
            <mat-error *ngIf="areaRatio?.invalid && areaRatio?.touched">
              <span class="myerror">A/A<sub>t</sub> &gt; 1</span>
            </mat-error>
          </mat-form-field>
          </div>
        </div>
        </div>
        
        <div class="flex justify-center items-baseline flex-wrap sbmtArea">
            <button mat-raised-button type="submit" [disabled]="areaRatioForm.invalid">Calculate</button>
      </div>
      <br>
</form>

<div class="flex justify-center items-baseline flex-wrap" *ngIf="aBool">
    <br><br>
    <table>
      <tr>
        <td>
            Mach
            <!-- <img src="assets/math/mach_b.svg" alt=""> -->
        </td>
        <td> {{ isenMach()}} </td>
      </tr>
      <tr>
        <td>
            p / p<sub>0</sub>
        </td>
        <td>
          {{ isenp_pt() | number:'.1-5' }}
        </td>
      </tr>
      <tr>
        <td>
            T / T<sub>0</sub>
        </td>
        <td>{{ isenT_Tt() | number:'.1-5'}}</td>
      </tr>
  
      <tr>
        <td>
            pA / p<sub>0</sub>A<sub>t</sub>
        </td>
        <td>
          {{ isenpA_ptAstar()  | number:'.1-5'  }}
        </td>
      </tr>
      <tr>
        <td>
            <span>Prandtl-Meyer flow (ν)</span>
        </td>
        <td>{{ isenpm() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <span>Mach angle (μ)</span>      
        </td>
        <td>{{ isenmach_angle() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
        <td>
            <span>C<sub>Fopt</sub></span>
        </td>
        <td>{{isen_cfopt() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
  
        <td>
            <span>ρ/ρ<sub>0</sub></span>
        </td>
        <td>{{ isen_rhot() | number:'.1-5' }}</td>
  
      </tr>
    </table>
  </div>